import axios from "axios";
import * as actionTypes from "./actionTypes";
import {buildUrlWithSearchParams} from '../utils/utilities';

const dominio = process.env.REACT_APP_DOMINIO;
let base_url = `${dominio}/emisoras/sectores`;

const setSector = (data = null) => {
  return {
    type: actionTypes.FETCH_SECTOR_SUCCESS,
    sectores: data
  };
};

export const filterSector = ({instrumento = null, tipoValor = null, tipoInscripcion = null, biva = null, canceladas = null}) => {
  const queryParams = {
    tipoInstrumento: instrumento,
    tipoValor: tipoValor,
    tipoInscripcion: tipoInscripcion,
    biva: biva,
    canceladas: canceladas
  };
  let url = buildUrlWithSearchParams(base_url, queryParams);

  return dispatch => {
    axios
      .get(url)
      .then(response => {
        dispatch(setSector(response.data));
      })
      .catch(() => dispatch(setSector()));
  };
};

const setSubSectores = (data = null) => {
  return {
    type: actionTypes.FETCH_SUBSECTOR_SUCCESS,
    sub_sectores: data
  };
};

export const filterSubSector = ({sector = null, instrumento = null, tipoValor = null, tipoInscripcion = null, biva = null, canceladas = null}) => {
  const queryParams = {
    tipoInstrumento: instrumento,
    tipoValor: tipoValor,
    tipoInscripcion: tipoInscripcion,
    biva: biva,
    canceladas: canceladas
  };
  let url = base_url;
  url = sector ? `${base_url}/${sector}/subsectores` : url;
  url = buildUrlWithSearchParams(url, queryParams);

  return dispatch => {
    axios
      .get(url)
      .then(response => {
        dispatch(setSubSectores(response.data));
      })
      .catch(() => dispatch(setSubSectores()));
  };
};
